import { ReactNode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { Loader } from '@/ui-kit/loader/Loader';

import { persistor, store } from '@/store/configuration';

interface IBootstrapProps {
  children: ReactNode;
}

export const Bootstrap = ({ children }: IBootstrapProps) => {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <Suspense fallback={<Loader />}>{children}</Suspense>
      </PersistGate>
    </Provider>
  );
};
